import mixpanel from "mixpanel-browser";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { routeList } from "../../App";
import { lang } from "../../assets/languages/en.language";
import DogNameCurved from "../../components/DogNameCurved.component";
import TraitInput from "../../components/form/Trait.input";
import { theme } from "../../configs/theme";
import api from "../../services/api";
import { useUserStore } from "../../store/useUserStore";
import { PurpleButton } from "../../styles/Button.style";
import { MainContainer, RootContainer } from "../../styles/Container.style";
import { Paragraph, Title } from "../../styles/Text";
import { Column, Gap } from "../../styles/Utils";

export default function AboutThemPage() {
  const [selectedTraits, setSelectedTraits] = useState<string[]>([]);
  const navigate = useNavigate();

  const {
    profile: { traits, dogName },
    setTraits,
  } = useUserStore();

  useEffect(() => {
    if (traits.length > 0) navigate(routeList.aboutYouConnectWith);
  });

  const handleSubmission = async () => {
    try {
      await api.addTraits({ traits: selectedTraits });
      mixpanel.track("Onboarding About Them Submit");
      setTraits(selectedTraits);
      navigate(routeList.aboutYouConnectWith);
    } catch (err) {
      console.log("Error adding traits", err);
      alert("Error adding traits");
    }
  };

  const formValid = selectedTraits.length == 3;

  return (
    <RootContainer $topSafe={true} $background={theme.color.primaryExtraLight}>
      <Column $alignItem="center" $maxHeight>
        <DogNameCurved dogName={dogName!} color={theme.color.primary} />
        <MainContainer>
          <Title>{lang.AboutThemPage.title}</Title>
          <Gap $height={1} />
          <Paragraph>{lang.AboutThemPage.message}</Paragraph>
          <Gap $height={1} />
          <TraitInput selectedTraits={selectedTraits} setSelectedTraits={setSelectedTraits} />
        </MainContainer>
        <Gap $height={1.5} />
        <PurpleButton type="submit" disabled={!formValid} onClick={handleSubmission}>
          <span>{lang.buttons.continue}</span>
        </PurpleButton>
      </Column>
    </RootContainer>
  );
}
